import { render, staticRenderFns } from "./InsuranceCompanyBtns.vue?vue&type=template&id=0addb5ca&"
import script from "./InsuranceCompanyBtns.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports